import { AuthProvider } from "./context/Auth";
import { ThemeProvider } from "./hooks/useTheme";
import { Routers } from "./routers/router";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: '#18181b', color: '#fff', borderRadius: '14px', fontSize: '14px' },
            success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
          }}
        />
        <Routers />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
